import { getDeviceName } from 'src/app/core/common';
import { FileActionEnum, MimeTypesEnum } from 'src/app/utils/enums';
import { environment } from 'src/environments/environment';
import { AccountService } from '../../auth/account.service';
import { BlobToPdfService } from '../../blob-to-pdf.service';
import { FileConvertorService } from '../file-convertor-service';
import { ConversionOptions } from '../models/conversion-options';
import { ConvertorParams } from '../models/convertor-params';
import { BaseConversion } from './base-conversion';

declare var platform;

export class KesToPdfConversion extends BaseConversion {
    protected file: File | null;
    protected url: string = environment.conversions.kesPdfUrl;
    protected type: MimeTypesEnum = MimeTypesEnum.ApplicationPdf;
    protected action: FileActionEnum = FileActionEnum.ImportKes;

    constructor(readonly services: [FileConvertorService, AccountService, BlobToPdfService]) {
        super(...services);
    }

    prepareConversionParams(): ConvertorParams | null {
        if (this.file === null || this.params === null) {
            return null;
        }

        const formData = new FormData();
        formData.append('file', this.file, this.file.name);

        return {
            action: this.action,
            type: this.type,
            formData,
            url: this.url,
            params: this.params,
            fileName: this.file.name,
            readingItemIdx: this.readingItemIdx || undefined,
            paneIndex: (this.paneIndex !== null ? this.paneIndex : null),
            metadata: this.metadata
        };
    }

    async setOptions(options: ConversionOptions): Promise<void> {
        options = options || {};
        const { file } = options;
        this.file = file || null;
        this.paneIndex = (options.paneIndex !== null ? options.paneIndex as number : null);
        this.metadata = (options.metadata ? options.metadata : null);

        const userInfo = await this.accountService.getAccountInfo();

        if (userInfo) {
            this.params = {
                DeviceId: userInfo.id.toUpperCase(),
                DeviceName: getDeviceName().toUpperCase(),
                DeviceOs: platform.os.toString()
            };
        }
    }
}
